import { Action } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'
import {
  OtherProductItem,
  OtherProducts,
  OtherProductSetParams,
  TransactionDetails,
  TransactionProductList,
} from '@/api/send_detail/model/sendMailModel'
import { getOtherProducts } from '@/api/send_detail/send_detail'
import { ONE_TIME_APPEND, PAGE_SIZE } from './constant'

const actions: { [actionTypes: string]: Action<State, any> } = {
  //登録済み商品追加
  [actionTypes.SET_PRODUCT_ADD_MODAL]: ({ commit }, status: boolean): void => {
    commit(actionTypes.SET_PRODUCT_ADD_MODAL, status)
  },

  //画面データ
  [actionTypes.SET_TRANSACTION_DETAILS]: (
    { commit },
    details: TransactionDetails
  ): void => {
    commit(actionTypes.SET_TRANSACTION_DETAILS, details)
    commit(actionTypes.SET_PRODUCT_LIST, details.product_list)
  },

  //受領ステータス
  [actionTypes.SET_RECEIVE_STATUS]: ({ commit }, status: number): void => {
    commit(actionTypes.SET_RECEIVE_STATUS, status)
  },

  [actionTypes.SET_PRODUCT_LIST]: ({ commit }, data): void => {
    commit(actionTypes.SET_PRODUCT_LIST, data)
  },

  [actionTypes.DELETE_PRDUCT_LIST]: ({ commit }, data: TransactionProductList): void => {
    commit(actionTypes.DELETE_PRDUCT_LIST, data)
  },

  //利用者別他社商品
  [actionTypes.SET_OTHER_PRODUCTS]: async (
    { commit, state },
    params: OtherProductSetParams
  ): Promise<void> => {
    // 全てのデータが取得済みでしたら取得をやめる
    const allDataGetted =
      // 請求直後に現在ページを 1 増加するので請求前に現在ページ数を取得するには -1 が必要
      state.total_count >= 0 && (state.current_page - 1) * PAGE_SIZE >= state.total_count

    if (!state.originalOtherProducts.length && allDataGetted) {
      return
    }

    // オリジナルデータが無くなれば新しく請求する
    if (!state.originalOtherProducts.length) {
      const result = await getOtherProducts(params.searchParams)
      let newDetails = [] as OtherProducts

      if (!result) {
        return
      }

      if (params.fillProductIds.length > 0) {
        //取引詳細画面既に紐付けた商品を非表示
        newDetails = result.detail.filter(
          (item) => params.fillProductIds.indexOf(item.product_id) === -1
        )
      } else {
        newDetails = [...result.detail]
      }

      commit(actionTypes.SET_ORIGINAL_OTHER_PRODUCTS, newDetails)
      commit(actionTypes.SET_OTHER_TOTAL_COUNT, result.total_count)
      commit(actionTypes.SET_OTHER_CURRENT_PAGE, result.current_page + 1)
    }

    // オリジナルから指定件数で取り出して表示データに追加
    const displayList: OtherProducts = [
      ...state.otherProducts,
      ...state.originalOtherProducts.filter(
        (_, index: number): boolean => index < ONE_TIME_APPEND
      ),
    ]

    // オリジナルから取り出したデータ指定件数分を削除して再設定
    commit(
      actionTypes.SET_ORIGINAL_OTHER_PRODUCTS,
      state.originalOtherProducts.filter(
        (_, index: number): boolean => index >= ONE_TIME_APPEND
      )
    )

    commit(actionTypes.SET_OTHER_PRODUCTS, displayList)
  },

  [actionTypes.CLEAR_OTHER_PRODUCTS]: ({ commit }): void => {
    commit(actionTypes.SET_ORIGINAL_OTHER_PRODUCTS, [])
    commit(actionTypes.CLEAR_OTHER_PRODUCTS)
    commit(actionTypes.SET_OTHER_CURRENT_PAGE, 1)
    commit(actionTypes.SET_OTHER_TOTAL_COUNT, -1)
  },

  [actionTypes.SET_OTHER_TOTAL_COUNT]: ({ commit }, status: number): void => {
    commit(actionTypes.SET_OTHER_TOTAL_COUNT, status)
  },

  [actionTypes.SET_OTHER_CURRENT_PAGE]: ({ commit }, status: number): void => {
    commit(actionTypes.SET_OTHER_CURRENT_PAGE, status)
  },

  [actionTypes.SET_OTHER_PAGE_SIZE]: ({ commit }, status: number): void => {
    commit(actionTypes.SET_OTHER_PAGE_SIZE, status)
  },

  [actionTypes.SET_OHTER_ADD_SUBMIT_MODAL]: ({ commit }, status: boolean): void => {
    commit(actionTypes.SET_OHTER_ADD_SUBMIT_MODAL, status)
  },

  [actionTypes.SET_SELECTED_OTHER_PRODUCT]: (
    { commit },
    data: OtherProductItem
  ): void => {
    commit(actionTypes.SET_SELECTED_OTHER_PRODUCT, data)
  },
}

export default actions
